import App from "./App";
import reportWebVitals from "./reportWebVitals";
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import "@fortawesome/free-solid-svg-icons";
import "@fortawesome/react-fontawesome";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./i18n";

/* ── Suppress ResizeObserver loop notification ──────────────────────────
   This is a benign browser notification (not an error) that fires when
   react-select recalculates menu position. CRA's dev overlay incorrectly
   treats it as a fatal error. We patch ResizeObserver itself to debounce
   callbacks, which prevents the loop notification from ever being raised. */
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    let rafId;
    super((entries, observer) => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => callback(entries, observer));
    });
  }
};

/* Belt-and-suspenders: also suppress at the event level */
window.addEventListener("error", (e) => {
  if (e?.message?.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
}, true);

const _onerror = window.onerror;
window.onerror = (msg, ...args) => {
  if (typeof msg === "string" && msg.includes("ResizeObserver loop")) return true;
  return _onerror ? _onerror(msg, ...args) : false;
};

ReactDOM.render(<App />, document.getElementById("root"));

reportWebVitals();
